import * as React from 'react'
import 'core-js/stable'
import { createRoot } from 'react-dom/client'
import { setHostHelpers } from '@mobi/account/Utils/hostHelpers'
import { iotSubscribeTopics } from '@mobi/utils/awsiot'
import { getGlobalPushSubscriptions } from '@mobi/utils/awsiot/topics'
import { init as initWebNativeComms } from '@mobi/web-native-comms/web'
import '@classic/AppUtils/Framework/CustomBindings/React'
import App from '@core/App'
import { getIsAuthenticated } from '@core/Areas/Login/helpers/api'
import { refreshLogonState } from '@core/Areas/Login/helpers/refreshLogonState'
import { startVenueModeService } from '@core/Areas/VenueMode/Service/venueModeService'
import { queryClient } from '@core/Data/ReactQuery'
import { serverConfigQuery } from '@core/Data/ServerConfig/query'
import {
  startDeepLinkingListeners,
  startLocationServiceListeners,
  startMetadataStatusUpdate,
  startPushNotificationsAuthStatus,
  startRaceKeyNotification,
  startUserLoginListeners,
  startWebviewIsAliveListener,
} from '@core/NativeServices'
import * as analyticsDataLayer from '@core/Services/Analytics/helpers/dataLayer'
import { initializeSentry } from '@core/Services/Sentry'
import { initializeLaunchDarklyServiceWithConfig } from '@core/State/FeatureFlags/LaunchDarklyService'
import '@core/State/PushData'
import { registerUserAccountSideEffects } from '@core/State/UserAccount/side-effects'
import { appHistory } from '@core/Utils/routing/history'
import * as rwwaRxStateMachineDevTools from '@core/Utils/rwwa-rx-state-machine-dev-tools'
import '../assets/scss/mobi.scss'

window.AnalyticsDataLayer = analyticsDataLayer

const [isAuthenticated, config] = await Promise.all([
  getIsAuthenticated(),
  queryClient.fetchQuery(serverConfigQuery),
])

const { enableSentryIo, sentryIoUrl, serverEnvironment } = config

if (enableSentryIo) {
  initializeSentry(sentryIoUrl, serverEnvironment)
}

const { launchDarklyClientID } = config
const { accountNumber } = isAuthenticated

await initializeLaunchDarklyServiceWithConfig(launchDarklyClientID, accountNumber)

setHostHelpers({ history: appHistory })
initWebNativeComms()

startDeepLinkingListeners()
startUserLoginListeners()
startLocationServiceListeners()
startPushNotificationsAuthStatus()
startMetadataStatusUpdate()
startRaceKeyNotification()
startVenueModeService()
startWebviewIsAliveListener()

// Register driver side effects here
registerUserAccountSideEffects()

await refreshLogonState(isAuthenticated)

// Render <App />
const container = document.getElementById('js-react-app')
if (container) {
  const root = createRoot(container)
  root.render(React.createElement(App, null))
}

// Do global push subscriptions
iotSubscribeTopics(getGlobalPushSubscriptions())

// Set up DEV tools
if (!PRODUCTION) {
  rwwaRxStateMachineDevTools.start()
  // @ts-expect-error DEV only global
  if (module.hot) module.hot.accept()
}
